export const getVersion = () => 'v1.4.25'
